// extracted by mini-css-extract-plugin
export default {"cls1":"Bego8b6jZQxRQCuBRgwN","cls2":"auGLvUn9wJO2W4bHPyGw Bego8b6jZQxRQCuBRgwN"};